import { TReply, TMessagesMap } from '../../types/messages';

interface ICreateWsReplyMessageParams {
  messagesMap: TMessagesMap;
  replyToMessageId?: string | null;
}

/**
 * @description
 * Создаёт reply (переписку) по сообщению.
 */
export function createWsReplyMessage({
  messagesMap,
  replyToMessageId: messageId,
}: ICreateWsReplyMessageParams): TReply | undefined {
  const repliedMessage = messageId ? messagesMap.get(messageId)?.message?.message : null;

  if (!messageId || !repliedMessage) {
    return;
  }

  const { userId: authorId, message: quoteText = '', files } = repliedMessage;

  /** Оффер */
  if (repliedMessage.type === 'offer') {
    return {
      type: 'offer',
      messageId,
      authorId,
      quoteText,
    };
  }

  /** Фото */
  const imageFile = files?.imagesAsDocuments?.[0] ?? files?.images?.[0];

  if (imageFile) {
    const { uid: quoteFileUid, name: quoteFileName } = imageFile;
    const isImagesAsDocument = Boolean(files?.imagesAsDocuments?.length);

    return {
      type: 'photo',
      messageId,
      authorId,
      quoteFileUid,
      quoteFileName,
      quoteText: isImagesAsDocument ? quoteFileName : quoteText,
    };
  }

  /** Документ */
  if (files?.documents?.length) {
    return {
      type: 'document',
      messageId,
      authorId,
      quoteText,
    };
  }

  /** Текст */
  return {
    type: 'text',
    messageId,
    authorId,
    quoteText,
  };
}
